<template>
    <aside class="left-panel flex-fill d-flex flex-column" style="min-width: 230px;max-width: 300px;">
        <div class="d-flex align-items-center justify-content-between px-2 py-2" panel>
            <span class="ps-0" style="font-size: small">Layers</span>
            <div class="d-flex pe-0">
                <div class="pe-1">
                    <button class="d-flex align-items-center justify-content-center border rounded-1" title="Add Layer" btn>
                        <i class="bi bi-plus text-white" style="font-size: small;"></i>
                    </button>
                </div>
                <div class="pe-1">
                    <button class="d-flex align-items-center justify-content-center border rounded-1" title="New Group" btn>
                        <i class="bi bi-front text-white" style="font-size: small;"></i>
                    </button>
                </div>
                <div class="pe-0">
                    <button class="d-flex align-items-center justify-content-center border rounded-1" title="More" btn>
                        <i class="bi bi-three-dots text-white" style="font-size: small;"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="">
            <ul class="p-1" ref="layers" panellist>
                <component
                    v-for="layer in layers"
                    :key="layer.uid || layer.id"
                    :is="resolveLayerComponent(layer)"
                    :selected="isLayerSelected(layer)"
                    @click.right="layerContextMenu(layer.uid)"
                />
            </ul>
        </div>
    </aside>
</template>

<script>
import FrameComp from './layers/FrameComp.vue';
import ImageComp from './layers/ImageComp.vue';
import TextComp from './layers/TextComp.vue';
import VectorComp from './layers/VectorComp.vue';
import LayerComp from '@/components/designer/layers/GroupLayerComp.vue';

// objects
import { FrameObject } from '@/lib/visionary/objects/frame.js';
import { VectorObject } from '@/lib/visionary/objects/vector.js';
import { ImageObject } from '@/lib/visionary/objects/image.js';

export default {
    name: 'LeftPanelComp',
    props: {
        layers: {
            type: Array,
            required: false
        }
    },
    components: {
        LayerComp,
        FrameComp,
        ImageComp,
        TextComp,
        VectorComp
    },
    data() {
        return {}
    },
    methods: {
        resolveLayerComponent(layer) {
            if (!layer) return LayerComp;

            if (layer instanceof FrameObject) return FrameComp;
            if (layer instanceof VectorObject) return VectorComp;
            if (layer instanceof ImageObject) return ImageComp;

            // Fallback for future object types
            return LayerComp;
        },
        isLayerSelected(layer) {
            return !!(layer && layer.selected);
        },
        layerContextMenu(layer_uid) {
            alert(`this will bring up the context menu: ${layer_uid}`);
        }
    },
    mounted() {
        const layers = this.$refs.layers;

        console.log(layers);
        // console.log(this.layers, layers);
    }
}
</script>

<style scoped>
.left-panel { 
    border-right: 1px solid var(--border); 
    background: var(--panel);
}

[btn] {
    width: 26px;
    height: 26px;
    background: none;
    border-color: var(--border) !important;
}

[panel] {
    border-bottom: 1px solid var(--border);
}

[panellist] {
    list-style: none;
    margin: 0;
    padding: 0;
}
/* .left-panel { border-right: 1px solid var(--border); background: var(--panel); display: grid; grid-template-rows: auto 1fr; }
.section-title { height: 36px; display: flex; align-items: center; justify-content: space-between; padding: 0 8px 0 10px; color: var(--muted); font-size: 12px; border-bottom: 1px solid var(--border); background: var(--panel); }
.section-title .actions { display: inline-flex; gap: 6px; }
.section-title .icon { height: 24px; min-width: 24px; padding: 0 6px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); cursor: pointer; font-size: 12px; }
.left-scroll { overflow: auto; padding: 6px; }


.layers { list-style: none; margin: 0; padding: 0; display: grid; }
.layer { border-radius: 6px; }
.layer .row { display: grid; grid-template-columns: 16px 20px 1fr auto; align-items: center; gap: 8px; padding: 6px 8px; border: 1px solid var(--border); background: var(--panel); border-radius: 6px; }
.layer.group .row { background: var(--panel-2); }
.layer.selected .row { border-color: var(--accent, #5b8cff); background: var(--panel-selected); }
.caret { width: 16px; text-align: center; color: var(--muted); }
.caret.placeholder { color: transparent; }
.thumb { width: 20px; height: 20px; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 11px; color: var(--muted); border: 1px solid var(--border); background: var(--panel-2, #1c2738); }
.thumb.board { border-style: dashed; }
.thumb.color { border: 1px solid var(--border); background: #ffffff; }
.thumb.text { font-weight: 700; }
.label { color: var(--text); font-size: 12px; }
.meta { color: var(--muted); font-size: 11px; }
.children { list-style: none; margin: 4px 0 0 20px; padding: 0; display: grid; gap: 4px; } */
</style>
